import { Goal } from './Goal';

export const kind = 'LogOut';

export type LogOut = Goal<typeof kind>;
